import React from "react";
import { Popup, EditableComponent, InputField } from "arteia-js/components";

import _ from "lodash";

import { API } from "arteia-js/services";
import queryString from "query-string";
import { backgroundArtworks } from "../configs/backgroundArtworks.config";

var artwork =
  backgroundArtworks[Math.floor(Math.random() * backgroundArtworks.length)];
class TwoFactorCode extends EditableComponent {
  state = {
    code: "",
    errorMessage: "",
  };

  errorMessages = {
    503: "Service unavailable",
    500: "Ooops, something went wrong",
    403: "Unauthorized",
    400: "Bad request",
    404: "Two Factor failed. Please try again.",
    421: "Wrong code",
  };

  allowSave = () => this.state.code.length > 0;

  confirmCode = () => {
    const { history } = this.props;
    const { twoFactorId, returnTo, isAdminPanel = false } = history.location.state;

    const { code } = this.state;

    return API.post("/login/confirm", { twoFactorId, code, isAdminPanel })
      .then((response) => {
        const { token } = response;

        if (returnTo === "client") {
          API.getOrganisations(token)
            .then((profile) => {
              const { organisations } = profile.data;
              let redirect = "";

              if (!organisations.length) {
                const query = {
                  token: token,
                  returnTo: "accounts-client",
                };

                this.setState({
                  status: 200,
                  errorCode: null,
                });

                return window.location.assign(
                  `/redirect?${queryString.stringify(query)}`
                );
              }

              const nonDemoOrg = organisations.find((org) => !org.is_demo);
              if (!nonDemoOrg) {
                redirect = organisations[0].url;
              } else {
                redirect = nonDemoOrg.url;
              }

              const parts = redirect.split("/");
              const newReturnTo = `client/org/${
                parts[parts.length - 1]
              }/artworks`;

              const query = {
                token: token,
                returnTo: newReturnTo,
              };

              this.setState({
                status: 200,
                errorCode: null,
              });

              return window.location.assign(
                `/redirect?${queryString.stringify(query)}`
              );
            })
            .catch((err) => {
              const { status } = err;

              if (err.status === 404) {
                return history.push("/login", {
                  errorMessage: this.errorMessages[err.status],
                });
              }

              this.setState({
                errorMessage:
                  this.ERROR_MESSAGES[status] || this.ERROR_MESSAGES[500],
              });
            });
        } else {
          const query = { token, returnTo };

          return window.location.assign(
            `/redirect?${queryString.stringify(query)}`
          );
        }
      })
      .catch((err) => {
        if (err.status === 404) {
          return history.push("/login", {
            errorMessage: this.errorMessages[err.status],
          });
        }
        return this.setState({
          errorMessage: this.errorMessages[err.status],
        });
      });
  };

  handleKeyPress = (e) => {
    const { code } = this.state;
    if (e.key === "Enter" && code.length > 0) {
      this.confirmCode();
    }
  };

  componentDidMount() {
    const { history } = this.props;
    const { state } = history.location;

    if (!state || !state.twoFactorId) {
      return history.push("/login");
    }
    return _.noop();
  }

  render() {
    const { code, errorMessage = "" } = this.state;

    return (
      <div
        className="two-factor-wrapper"
        style={{ backgroundImage: `url(${artwork.asset})` }}
      >
        <div className="artwork-details">
          <span className="artist-name">{artwork.artistName}</span>
          <br />
          <span className="artwork-title">
            {artwork.title}, {artwork.year}
          </span>
        </div>
        <span className="all-rights-reserved">
          &copy; {new Date().getFullYear()} Arteïa - All rights reserved
        </span>
        <Popup size="form" noTitle noCloseHandler className="form">
          <div className="popup-content">
            <span className="input-label">Verification code</span>
            <InputField
              value={code}
              onChange={this.onFieldChange("code")}
              handleKeyPress={this.handleKeyPress}
              autoFocus
            />

            <div className="form-msg">
              <span className="error-msg">
                {errorMessage.length !== 0 && errorMessage}
              </span>
            </div>
            <div className="button-container">
              <button
                className="art-btn"
                disabled={!this.allowSave()}
                onClick={this.confirmCode}
              >
                Confirm
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}

TwoFactorCode.propTypes = {};
TwoFactorCode.defaultProps = {};

export default TwoFactorCode;



// WEBPACK FOOTER //
// ./src/scenes/TwoFactorCode/index.js